// extracted by mini-css-extract-plugin
export default {"body-container":"BodyLayout_body-container__MgaUm","center":"BodyLayout_center__Zb-VI"};